export enum HubspotEnrichmentItemTypeEnum {
  CONTACT = "CONTACT",
  LEAD = "LEAD",
  COMPANY = "COMPANY",
  OPPORTUNITY = "OPPORTUNITY"
}

export const HubspotEnrichmentItemTypeNames: Record<HubspotEnrichmentItemTypeEnum, string> = {
  [HubspotEnrichmentItemTypeEnum.CONTACT]: 'Contact',
  [HubspotEnrichmentItemTypeEnum.LEAD]: 'Lead',
  [HubspotEnrichmentItemTypeEnum.COMPANY]: 'Company',
  [HubspotEnrichmentItemTypeEnum.OPPORTUNITY]: 'Buying Center',
}

export type ItemTypeValueType = HubspotEnrichmentItemTypeEnum.CONTACT | HubspotEnrichmentItemTypeEnum.COMPANY | HubspotEnrichmentItemTypeEnum.OPPORTUNITY;
